import {OnBaseDocumentData} from '../types/OnBaseDocumentData'

async function RequeueFailedDocument(doc: OnBaseDocumentData)
{

      try {
      
        const baseURL = process.env.REACT_APP_ONBASE_SUPPORT_API_URL;
        const endURL = '/api/RequeueFailedDocument';

        const response = await fetch(
          baseURL + endURL,
          {
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            body: JSON.stringify(doc)
          }
        );

        if (response.ok) {
          console.log("Requeue successful");
        } else {
          throw new Error('Error Requeing OnBase Failed Document');
        }
      } catch (error) {
        console.error('Error Requeing OnBase Failed Document:', error);
      }
    };

export default RequeueFailedDocument;